import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { PostDataFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface FileComponentProps {
  filename: string
  onClick: () => void
}

function getFileNameAndExtension(fullFilename: string) {
  const filename = fullFilename.replace(/\.[^/.]+$/, '')
  const extension = fullFilename.split('.').pop()

  return [filename, extension]
}

const File = ({ filename, onClick }: FileComponentProps) => {
  const [_filename, extension] = getFileNameAndExtension(filename)

  return (
    <Box
      background="grey200"
      flexDirection="row"
      alignItems="center"
      paddingX="s8"
      paddingY="s6"
      maxWidth="s240"
      borderRadius={{
        all: 'abs006',
      }}
      style={{ marginBottom: '8px', marginRight: '8px' }}
      aria-label={i18n.t('posts.communities.aria_label_holds_post_attachment')}
    >
      <Box flexDirection="row" alignItems="center">
        <Box style={{ marginRight: '4px' }}>
          <Icon.Medium icon="file-filled" color="grey800" />
        </Box>
        <Box flexDirection="row" alignItems="center">
          <Box maxWidth="s120">
            <Text.Normal size="100" weight="medium" color="grey1000" ellipsis overflowWrap>
              {_filename}.
            </Text.Normal>
          </Box>
          <Text.Normal size="100" weight="medium" color="grey1000">
            {extension}
          </Text.Normal>
        </Box>
        <Box
          style={{ marginLeft: '6px' }}
          aria-label={i18n.t('posts.communities.aria_label_removes_previous_added_post_attachment')}
        >
          <Touchable onClick={onClick}>
            <Icon.Small icon="close" color="grey800" />
          </Touchable>
        </Box>
      </Box>
    </Box>
  )
}

interface Props {
  post: PostDataFragment
  attachmentIdsToDelete: string[]
  setAttachmentIdsToDelete: (ids: string[]) => void
}

export default function FileList({ post, attachmentIdsToDelete, setAttachmentIdsToDelete }: Props) {
  const deleteAttachment = (id: string) => {
    setAttachmentIdsToDelete([...attachmentIdsToDelete, id])
  }

  const AttachmentList = post.savedAttachmentsConnection.edges
    .filter(({ node: attachment }) => !attachmentIdsToDelete.includes(attachment.id))
    .map(({ node: attachment }) => {
      return (
        <File
          key={attachment.id}
          filename={attachment.filename}
          onClick={() => deleteAttachment(attachment.id)}
        />
      )
    })

  return post.savedAttachmentsConnection.edges.length ? (
    <Box paddingBottom="s8">
      <Text.Normal size="200">{i18n.t('posts.communities.previous_attachments')}</Text.Normal>
      <Box
        flexWrap="wrap"
        flexDirection="row"
        alignItems="center"
        paddingTop="s4"
        aria-label={i18n.t('posts.communities.aria_label_list_of_previous_added_attachments')}
      >
        {AttachmentList}
      </Box>
    </Box>
  ) : null
}
